export enum UserRole {
  Guest = 'guest',
  User = 'user',
  Admin = 'admin',
  Any = 'any',
  Auditor = 'auditor',
}
